<yzb-form
  #save
  [dict]="dict"
  [curd]="2"
  [loading]="loading"
  (initFormEvent)="onInitForm($event)"
  (getFormDataEvent)="onGetFormData($event)"
  (setFormDataEvent)="onSetFormData($event)"
>
</yzb-form>
